<template>
  <div class="container container--narrow pdt-50 pdb-50">
    <div class="t-subtitle6 font-r t-line-h-26 d-flex -align-items-center">
      {{ question.number }}. {{ question.contents.text }}
      <span class="t-color-mainBtn" v-if="question.essential">*</span>
    </div>
    <div class="mgt-24" v-if="question.contents && question.contents.image">
      <img :src="question.contents.image" alt="" class="b-radius4 survey-banner" />
    </div>
    <div class="mgt-24">
      <label class="mdc-text-field mdc-text-field--outlined mdc-text-field--textarea w-full customize-textfield--outlined"
        data-mdc-auto-init="MDCTextField" id="textEl">
        <span class="mdc-text-field__ripple"></span>
        <textarea class="mdc-text-field__input t-body6 font-r pdl-14 pdr-15 pdb-34 t-line-h-26 l-spacing2" id="textarea"
          rows="11" :maxlength="question.textBody.charNumber" v-model="text" cols="10"></textarea>
        <span class="mdc-line-ripple"></span>
        <div class="mdc-notched-outline" :class="errorBool === false ? 'errorClass' : ''">
          <div class="mdc-notched-outline__leading"></div>
          <div class="mdc-notched-outline__notch"></div>
          <div class="mdc-notched-outline__trailing"></div>
        </div>
      </label>
    </div>

    <div class="mgt-100"></div>
  </div>
</template>


<script>
/**
 * 설문 - 단답형 문항 컴포넌트(survey - short answer question component)
 *
 * @author minkyoung.park@emcast.com
 */

// Components/Mixin/Extend/API define
import { MDCTextField } from "@material/textfield";

export default {
  props: ["question", "setedAnswer"],

  data() {
    return {
      text: "",
      errorBool: true,
    };
  },

  mounted() {
    this.text = this.setedAnswer.text;
    this.attachMertial();
  },

  updated() {
    this.attachMertial();
  },

  watch: {
    text: function (value) {
      this.setAnswer();
    },
  },

  methods: {
    attachMertial() {
      const textField = new MDCTextField(document.getElementById("textEl"));
    },

    //답안정보 설정 및 부모 컴포넌트에 전달(set answer / transfer parent component)
    setAnswer() {
      let params = {
        questionId: this.question.id,
        text: this.text,
        comment: "",
        selected: [],
        weight: {},
        isSolved: this.isSolved(),
      };
      this.$emit("setAnswers", params);
    },

    // 응답 여부 확인(check solved )
    isSolved() {
      return !!this.text;
    },
    validateTextArea() {
      let valType = this.question.textBody.validatorType;
      switch (valType) {
        case "WITH_SPECIAL_CHARACTER":
          // this.ValidateWithSpecial(this.text);
          break;
        case "WITHOUT_SPECIAL_CHARACTER":
          this.ValidateWithOutSpecial(this.text);
          break;
        case "EMAIL":
          this.ValidateEmail(this.text);
          break;
        case "NUMBER":
          this.ValidateNumber(this.text);
          break;
        case "NONE":
          this.ValidateNone(this.text);
          break;
        default:
          let text = "I have never heard of that fruit...";
      }
      return this.errorBool;
    },
    ValidateEmail(inputText) {
      let re =
        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      this.errorBool = re.test(inputText);
    },
    ValidateNumber(inputText) {
      this.errorBool = !/\D/.test(inputText);
    },
    ValidateNone() {
      this.errorBool = true;
    },
    ValidateWithSpecial(inputText) {
      let re = /[^a-z0-9\\,\\.\\;]/;
      this.errorBool = re.test(inputText);
    },
    ValidateWithOutSpecial(inputText) {
      let re = /[!@#$%^&*(),.?":{}|<>]/g;
      this.errorBool = !re.test(inputText);
    },
  },
};
</script>

<style scoped>
.errorClass .mdc-notched-outline__leading,
.errorClass .mdc-notched-outline__trailing {
  border-color: var(--Textfeilderror) !important;
}

.customize-textfield--outlined {
  border: none !important;
  border-radius: 4px;
}
</style>
